"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ic_1st__month__free", {
  enumerable: true,
  get: function get() {
    return _ic_1st__month__free.default;
  }
});
Object.defineProperty(exports, "ic_3g", {
  enumerable: true,
  get: function get() {
    return _ic_3g.default;
  }
});
Object.defineProperty(exports, "ic_4g", {
  enumerable: true,
  get: function get() {
    return _ic_4g.default;
  }
});
Object.defineProperty(exports, "ic_4g__plus", {
  enumerable: true,
  get: function get() {
    return _ic_4g__plus.default;
  }
});
Object.defineProperty(exports, "ic_4g__plus__plus", {
  enumerable: true,
  get: function get() {
    return _ic_4g__plus__plus.default;
  }
});
Object.defineProperty(exports, "ic_5G", {
  enumerable: true,
  get: function get() {
    return _ic_5g.default;
  }
});
Object.defineProperty(exports, "ic_acceleration__low", {
  enumerable: true,
  get: function get() {
    return _ic_acceleration__low.default;
  }
});
Object.defineProperty(exports, "ic_acceleration", {
  enumerable: true,
  get: function get() {
    return _ic_acceleration.default;
  }
});
Object.defineProperty(exports, "ic_accelerationdle__mid", {
  enumerable: true,
  get: function get() {
    return _ic_accelerationdle__mid.default;
  }
});
Object.defineProperty(exports, "ic_accelerationdle", {
  enumerable: true,
  get: function get() {
    return _ic_accelerationdle.default;
  }
});
Object.defineProperty(exports, "ic_accessories", {
  enumerable: true,
  get: function get() {
    return _ic_accessories.default;
  }
});
Object.defineProperty(exports, "ic_add__ons__boosts", {
  enumerable: true,
  get: function get() {
    return _ic_add__ons__boosts.default;
  }
});
Object.defineProperty(exports, "ic_admin", {
  enumerable: true,
  get: function get() {
    return _ic_admin.default;
  }
});
Object.defineProperty(exports, "ic_alexa", {
  enumerable: true,
  get: function get() {
    return _ic_alexa.default;
  }
});
Object.defineProperty(exports, "ic_all__rewards", {
  enumerable: true,
  get: function get() {
    return _ic_all__rewards.default;
  }
});
Object.defineProperty(exports, "ic_apps", {
  enumerable: true,
  get: function get() {
    return _ic_apps.default;
  }
});
Object.defineProperty(exports, "ic_backspace", {
  enumerable: true,
  get: function get() {
    return _ic_backspace.default;
  }
});
Object.defineProperty(exports, "ic_barcode", {
  enumerable: true,
  get: function get() {
    return _ic_barcode.default;
  }
});
Object.defineProperty(exports, "ic_battery__low", {
  enumerable: true,
  get: function get() {
    return _ic_battery__low.default;
  }
});
Object.defineProperty(exports, "ic_battery", {
  enumerable: true,
  get: function get() {
    return _ic_battery.default;
  }
});
Object.defineProperty(exports, "ic_battery__really__low", {
  enumerable: true,
  get: function get() {
    return _ic_battery__really__low.default;
  }
});
Object.defineProperty(exports, "ic_bill", {
  enumerable: true,
  get: function get() {
    return _ic_bill.default;
  }
});
Object.defineProperty(exports, "ic_bill__or__report", {
  enumerable: true,
  get: function get() {
    return _ic_bill__or__report.default;
  }
});
Object.defineProperty(exports, "ic_bill__pay__phone", {
  enumerable: true,
  get: function get() {
    return _ic_bill__pay__phone.default;
  }
});
Object.defineProperty(exports, "ic_biometric__authentication", {
  enumerable: true,
  get: function get() {
    return _ic_biometric__authentication.default;
  }
});
Object.defineProperty(exports, "ic_birthday__greeting", {
  enumerable: true,
  get: function get() {
    return _ic_birthday__greeting.default;
  }
});
Object.defineProperty(exports, "ic_blog", {
  enumerable: true,
  get: function get() {
    return _ic_blog.default;
  }
});
Object.defineProperty(exports, "ic_bonus", {
  enumerable: true,
  get: function get() {
    return _ic_bonus.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__active", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__active.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__disabled", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__disabled.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__generic", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__generic.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__not__found", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__not__found.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__off", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__off.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__on", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__on.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__put__on", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__put__on.default;
  }
});
Object.defineProperty(exports, "ic_bracelet__remove", {
  enumerable: true,
  get: function get() {
    return _ic_bracelet__remove.default;
  }
});
Object.defineProperty(exports, "ic_broadband", {
  enumerable: true,
  get: function get() {
    return _ic_broadband.default;
  }
});
Object.defineProperty(exports, "ic_broadband__or__wifi", {
  enumerable: true,
  get: function get() {
    return _ic_broadband__or__wifi.default;
  }
});
Object.defineProperty(exports, "ic_bundles", {
  enumerable: true,
  get: function get() {
    return _ic_bundles.default;
  }
});
Object.defineProperty(exports, "ic_business", {
  enumerable: true,
  get: function get() {
    return _ic_business.default;
  }
});
Object.defineProperty(exports, "ic_calculator", {
  enumerable: true,
  get: function get() {
    return _ic_calculator.default;
  }
});
Object.defineProperty(exports, "ic_calendar", {
  enumerable: true,
  get: function get() {
    return _ic_calendar.default;
  }
});
Object.defineProperty(exports, "ic_calls__contacts", {
  enumerable: true,
  get: function get() {
    return _ic_calls__contacts.default;
  }
});
Object.defineProperty(exports, "ic_camera", {
  enumerable: true,
  get: function get() {
    return _ic_camera.default;
  }
});
Object.defineProperty(exports, "ic_cancel", {
  enumerable: true,
  get: function get() {
    return _ic_cancel.default;
  }
});
Object.defineProperty(exports, "ic_case__study", {
  enumerable: true,
  get: function get() {
    return _ic_case__study.default;
  }
});
Object.defineProperty(exports, "ic_chart__bar", {
  enumerable: true,
  get: function get() {
    return _ic_chart__bar.default;
  }
});
Object.defineProperty(exports, "ic_chart__line", {
  enumerable: true,
  get: function get() {
    return _ic_chart__line.default;
  }
});
Object.defineProperty(exports, "ic_chat", {
  enumerable: true,
  get: function get() {
    return _ic_chat.default;
  }
});
Object.defineProperty(exports, "ic_clock__or__timed", {
  enumerable: true,
  get: function get() {
    return _ic_clock__or__timed.default;
  }
});
Object.defineProperty(exports, "ic_clock__or__timeout", {
  enumerable: true,
  get: function get() {
    return _ic_clock__or__timeout.default;
  }
});
Object.defineProperty(exports, "ic_cloud__download", {
  enumerable: true,
  get: function get() {
    return _ic_cloud__download.default;
  }
});
Object.defineProperty(exports, "ic_cloud__upload", {
  enumerable: true,
  get: function get() {
    return _ic_cloud__upload.default;
  }
});
Object.defineProperty(exports, "ic_cloud__upload__storage", {
  enumerable: true,
  get: function get() {
    return _ic_cloud__upload__storage.default;
  }
});
Object.defineProperty(exports, "ic_comment", {
  enumerable: true,
  get: function get() {
    return _ic_comment.default;
  }
});
Object.defineProperty(exports, "ic_community", {
  enumerable: true,
  get: function get() {
    return _ic_community.default;
  }
});
Object.defineProperty(exports, "ic_community__or__foundation", {
  enumerable: true,
  get: function get() {
    return _ic_community__or__foundation.default;
  }
});
Object.defineProperty(exports, "ic_complaints", {
  enumerable: true,
  get: function get() {
    return _ic_complaints.default;
  }
});
Object.defineProperty(exports, "ic_completed", {
  enumerable: true,
  get: function get() {
    return _ic_completed.default;
  }
});
Object.defineProperty(exports, "ic_connected__car", {
  enumerable: true,
  get: function get() {
    return _ic_connected__car.default;
  }
});
Object.defineProperty(exports, "ic_connected__devices", {
  enumerable: true,
  get: function get() {
    return _ic_connected__devices.default;
  }
});
Object.defineProperty(exports, "ic_connectivity", {
  enumerable: true,
  get: function get() {
    return _ic_connectivity.default;
  }
});
Object.defineProperty(exports, "ic_consultant", {
  enumerable: true,
  get: function get() {
    return _ic_consultant.default;
  }
});
Object.defineProperty(exports, "ic_contest", {
  enumerable: true,
  get: function get() {
    return _ic_contest.default;
  }
});
Object.defineProperty(exports, "ic_control__panel", {
  enumerable: true,
  get: function get() {
    return _ic_control__panel.default;
  }
});
Object.defineProperty(exports, "ic_converged__proposition", {
  enumerable: true,
  get: function get() {
    return _ic_converged__proposition.default;
  }
});
Object.defineProperty(exports, "ic_country__or__international", {
  enumerable: true,
  get: function get() {
    return _ic_country__or__international.default;
  }
});
Object.defineProperty(exports, "ic_dashboard", {
  enumerable: true,
  get: function get() {
    return _ic_dashboard.default;
  }
});
Object.defineProperty(exports, "ic_data", {
  enumerable: true,
  get: function get() {
    return _ic_data.default;
  }
});
Object.defineProperty(exports, "ic_deals", {
  enumerable: true,
  get: function get() {
    return _ic_deals.default;
  }
});
Object.defineProperty(exports, "ic_delivery", {
  enumerable: true,
  get: function get() {
    return _ic_delivery.default;
  }
});
Object.defineProperty(exports, "ic_desktop", {
  enumerable: true,
  get: function get() {
    return _ic_desktop.default;
  }
});
Object.defineProperty(exports, "ic_device__overview", {
  enumerable: true,
  get: function get() {
    return _ic_device__overview.default;
  }
});
Object.defineProperty(exports, "ic_diagnostics", {
  enumerable: true,
  get: function get() {
    return _ic_diagnostics.default;
  }
});
Object.defineProperty(exports, "ic_dial__pad", {
  enumerable: true,
  get: function get() {
    return _ic_dial__pad.default;
  }
});
Object.defineProperty(exports, "ic_document__doc", {
  enumerable: true,
  get: function get() {
    return _ic_document__doc.default;
  }
});
Object.defineProperty(exports, "ic_document__jpg", {
  enumerable: true,
  get: function get() {
    return _ic_document__jpg.default;
  }
});
Object.defineProperty(exports, "ic_document", {
  enumerable: true,
  get: function get() {
    return _ic_document.default;
  }
});
Object.defineProperty(exports, "ic_document__pdf", {
  enumerable: true,
  get: function get() {
    return _ic_document__pdf.default;
  }
});
Object.defineProperty(exports, "ic_document__png", {
  enumerable: true,
  get: function get() {
    return _ic_document__png.default;
  }
});
Object.defineProperty(exports, "ic_document__ppt", {
  enumerable: true,
  get: function get() {
    return _ic_document__ppt.default;
  }
});
Object.defineProperty(exports, "ic_document__rtf", {
  enumerable: true,
  get: function get() {
    return _ic_document__rtf.default;
  }
});
Object.defineProperty(exports, "ic_document__svg", {
  enumerable: true,
  get: function get() {
    return _ic_document__svg.default;
  }
});
Object.defineProperty(exports, "ic_document__xls", {
  enumerable: true,
  get: function get() {
    return _ic_document__xls.default;
  }
});
Object.defineProperty(exports, "ic_document__zip", {
  enumerable: true,
  get: function get() {
    return _ic_document__zip.default;
  }
});
Object.defineProperty(exports, "ic_download", {
  enumerable: true,
  get: function get() {
    return _ic_download.default;
  }
});
Object.defineProperty(exports, "ic_e__sim", {
  enumerable: true,
  get: function get() {
    return _ic_e__sim.default;
  }
});
Object.defineProperty(exports, "ic_edit", {
  enumerable: true,
  get: function get() {
    return _ic_edit.default;
  }
});
Object.defineProperty(exports, "ic_engineer", {
  enumerable: true,
  get: function get() {
    return _ic_engineer.default;
  }
});
Object.defineProperty(exports, "ic_enterprise", {
  enumerable: true,
  get: function get() {
    return _ic_enterprise.default;
  }
});
Object.defineProperty(exports, "ic_entertainment", {
  enumerable: true,
  get: function get() {
    return _ic_entertainment.default;
  }
});
Object.defineProperty(exports, "ic_environment", {
  enumerable: true,
  get: function get() {
    return _ic_environment.default;
  }
});
Object.defineProperty(exports, "ic_fall__detection__emergency", {
  enumerable: true,
  get: function get() {
    return _ic_fall__detection__emergency.default;
  }
});
Object.defineProperty(exports, "ic_family", {
  enumerable: true,
  get: function get() {
    return _ic_family.default;
  }
});
Object.defineProperty(exports, "ic_filter", {
  enumerable: true,
  get: function get() {
    return _ic_filter.default;
  }
});
Object.defineProperty(exports, "ic_find__and__ring__your__device", {
  enumerable: true,
  get: function get() {
    return _ic_find__and__ring__your__device.default;
  }
});
Object.defineProperty(exports, "ic_fixed__line", {
  enumerable: true,
  get: function get() {
    return _ic_fixed__line.default;
  }
});
Object.defineProperty(exports, "ic_focus", {
  enumerable: true,
  get: function get() {
    return _ic_focus.default;
  }
});
Object.defineProperty(exports, "ic_game__console", {
  enumerable: true,
  get: function get() {
    return _ic_game__console.default;
  }
});
Object.defineProperty(exports, "ic_generic__tariff__plan", {
  enumerable: true,
  get: function get() {
    return _ic_generic__tariff__plan.default;
  }
});
Object.defineProperty(exports, "ic_gravity", {
  enumerable: true,
  get: function get() {
    return _ic_gravity.default;
  }
});
Object.defineProperty(exports, "ic_gyroscope", {
  enumerable: true,
  get: function get() {
    return _ic_gyroscope.default;
  }
});
Object.defineProperty(exports, "ic_healthy__living", {
  enumerable: true,
  get: function get() {
    return _ic_healthy__living.default;
  }
});
Object.defineProperty(exports, "ic_help__at__hand", {
  enumerable: true,
  get: function get() {
    return _ic_help__at__hand.default;
  }
});
Object.defineProperty(exports, "ic_help", {
  enumerable: true,
  get: function get() {
    return _ic_help.default;
  }
});
Object.defineProperty(exports, "ic_home", {
  enumerable: true,
  get: function get() {
    return _ic_home.default;
  }
});
Object.defineProperty(exports, "ic_idea__or__innovation", {
  enumerable: true,
  get: function get() {
    return _ic_idea__or__innovation.default;
  }
});
Object.defineProperty(exports, "ic_incoming__call", {
  enumerable: true,
  get: function get() {
    return _ic_incoming__call.default;
  }
});
Object.defineProperty(exports, "ic_info__circle", {
  enumerable: true,
  get: function get() {
    return _ic_info__circle.default;
  }
});
Object.defineProperty(exports, "ic_infographic", {
  enumerable: true,
  get: function get() {
    return _ic_infographic.default;
  }
});
Object.defineProperty(exports, "ic_interchangable__batteries", {
  enumerable: true,
  get: function get() {
    return _ic_interchangable__batteries.default;
  }
});
Object.defineProperty(exports, "ic_kippy__device", {
  enumerable: true,
  get: function get() {
    return _ic_kippy__device.default;
  }
});
Object.defineProperty(exports, "ic_landline__or__call", {
  enumerable: true,
  get: function get() {
    return _ic_landline__or__call.default;
  }
});
Object.defineProperty(exports, "ic_location", {
  enumerable: true,
  get: function get() {
    return _ic_location.default;
  }
});
Object.defineProperty(exports, "ic_mail__new", {
  enumerable: true,
  get: function get() {
    return _ic_mail__new.default;
  }
});
Object.defineProperty(exports, "ic_mesh__wifi__and__repeater", {
  enumerable: true,
  get: function get() {
    return _ic_mesh__wifi__and__repeater.default;
  }
});
Object.defineProperty(exports, "ic_minutes__sms", {
  enumerable: true,
  get: function get() {
    return _ic_minutes__sms.default;
  }
});
Object.defineProperty(exports, "ic_mobile", {
  enumerable: true,
  get: function get() {
    return _ic_mobile.default;
  }
});
Object.defineProperty(exports, "ic_monitor__brightness__contrast", {
  enumerable: true,
  get: function get() {
    return _ic_monitor__brightness__contrast.default;
  }
});
Object.defineProperty(exports, "ic_music__and__movies", {
  enumerable: true,
  get: function get() {
    return _ic_music__and__movies.default;
  }
});
Object.defineProperty(exports, "ic_mute", {
  enumerable: true,
  get: function get() {
    return _ic_mute.default;
  }
});
Object.defineProperty(exports, "ic_my__vodafone", {
  enumerable: true,
  get: function get() {
    return _ic_my__vodafone.default;
  }
});
Object.defineProperty(exports, "ic_my__vodafone__or__my__profile", {
  enumerable: true,
  get: function get() {
    return _ic_my__vodafone__or__my__profile.default;
  }
});
Object.defineProperty(exports, "ic_need__help", {
  enumerable: true,
  get: function get() {
    return _ic_need__help.default;
  }
});
Object.defineProperty(exports, "ic_network__signal", {
  enumerable: true,
  get: function get() {
    return _ic_network__signal.default;
  }
});
Object.defineProperty(exports, "ic_newest__tech", {
  enumerable: true,
  get: function get() {
    return _ic_newest__tech.default;
  }
});
Object.defineProperty(exports, "ic_news", {
  enumerable: true,
  get: function get() {
    return _ic_news.default;
  }
});
Object.defineProperty(exports, "ic_night__vision", {
  enumerable: true,
  get: function get() {
    return _ic_night__vision.default;
  }
});
Object.defineProperty(exports, "ic_notifications", {
  enumerable: true,
  get: function get() {
    return _ic_notifications.default;
  }
});
Object.defineProperty(exports, "ic_notifications__muted", {
  enumerable: true,
  get: function get() {
    return _ic_notifications__muted.default;
  }
});
Object.defineProperty(exports, "ic_outgoing__call", {
  enumerable: true,
  get: function get() {
    return _ic_outgoing__call.default;
  }
});
Object.defineProperty(exports, "ic_padlock__close", {
  enumerable: true,
  get: function get() {
    return _ic_padlock__close.default;
  }
});
Object.defineProperty(exports, "ic_padlock__open", {
  enumerable: true,
  get: function get() {
    return _ic_padlock__open.default;
  }
});
Object.defineProperty(exports, "ic_parental__control", {
  enumerable: true,
  get: function get() {
    return _ic_parental__control.default;
  }
});
Object.defineProperty(exports, "ic_pause", {
  enumerable: true,
  get: function get() {
    return _ic_pause.default;
  }
});
Object.defineProperty(exports, "ic_payg", {
  enumerable: true,
  get: function get() {
    return _ic_payg.default;
  }
});
Object.defineProperty(exports, "ic_payg__plans", {
  enumerable: true,
  get: function get() {
    return _ic_payg__plans.default;
  }
});
Object.defineProperty(exports, "ic_payment", {
  enumerable: true,
  get: function get() {
    return _ic_payment.default;
  }
});
Object.defineProperty(exports, "ic_photos", {
  enumerable: true,
  get: function get() {
    return _ic_photos.default;
  }
});
Object.defineProperty(exports, "ic_placeholder", {
  enumerable: true,
  get: function get() {
    return _ic_placeholder.default;
  }
});
Object.defineProperty(exports, "ic_play", {
  enumerable: true,
  get: function get() {
    return _ic_play.default;
  }
});
Object.defineProperty(exports, "ic_pop__out", {
  enumerable: true,
  get: function get() {
    return _ic_pop__out.default;
  }
});
Object.defineProperty(exports, "ic_portals__for__videos", {
  enumerable: true,
  get: function get() {
    return _ic_portals__for__videos.default;
  }
});
Object.defineProperty(exports, "ic_prepare", {
  enumerable: true,
  get: function get() {
    return _ic_prepare.default;
  }
});
Object.defineProperty(exports, "ic_price__promise", {
  enumerable: true,
  get: function get() {
    return _ic_price__promise.default;
  }
});
Object.defineProperty(exports, "ic_price__tag", {
  enumerable: true,
  get: function get() {
    return _ic_price__tag.default;
  }
});
Object.defineProperty(exports, "ic_public__sector", {
  enumerable: true,
  get: function get() {
    return _ic_public__sector.default;
  }
});
Object.defineProperty(exports, "ic_public__wifi", {
  enumerable: true,
  get: function get() {
    return _ic_public__wifi.default;
  }
});
Object.defineProperty(exports, "ic_qr__code", {
  enumerable: true,
  get: function get() {
    return _ic_qr__code.default;
  }
});
Object.defineProperty(exports, "ic_raffles", {
  enumerable: true,
  get: function get() {
    return _ic_raffles.default;
  }
});
Object.defineProperty(exports, "ic_return__product", {
  enumerable: true,
  get: function get() {
    return _ic_return__product.default;
  }
});
Object.defineProperty(exports, "ic_roaming", {
  enumerable: true,
  get: function get() {
    return _ic_roaming.default;
  }
});
Object.defineProperty(exports, "ic_router", {
  enumerable: true,
  get: function get() {
    return _ic_router.default;
  }
});
Object.defineProperty(exports, "ic_saving", {
  enumerable: true,
  get: function get() {
    return _ic_saving.default;
  }
});
Object.defineProperty(exports, "ic_screen__repair", {
  enumerable: true,
  get: function get() {
    return _ic_screen__repair.default;
  }
});
Object.defineProperty(exports, "ic_search", {
  enumerable: true,
  get: function get() {
    return _ic_search.default;
  }
});
Object.defineProperty(exports, "ic_security__camera", {
  enumerable: true,
  get: function get() {
    return _ic_security__camera.default;
  }
});
Object.defineProperty(exports, "ic_security", {
  enumerable: true,
  get: function get() {
    return _ic_security.default;
  }
});
Object.defineProperty(exports, "ic_settings", {
  enumerable: true,
  get: function get() {
    return _ic_settings.default;
  }
});
Object.defineProperty(exports, "ic_shopping__trolley", {
  enumerable: true,
  get: function get() {
    return _ic_shopping__trolley.default;
  }
});
Object.defineProperty(exports, "ic_sim", {
  enumerable: true,
  get: function get() {
    return _ic_sim.default;
  }
});
Object.defineProperty(exports, "ic_sim__swap", {
  enumerable: true,
  get: function get() {
    return _ic_sim__swap.default;
  }
});
Object.defineProperty(exports, "ic_small__and__lightweight", {
  enumerable: true,
  get: function get() {
    return _ic_small__and__lightweight.default;
  }
});
Object.defineProperty(exports, "ic_sme", {
  enumerable: true,
  get: function get() {
    return _ic_sme.default;
  }
});
Object.defineProperty(exports, "ic_sms__or__text", {
  enumerable: true,
  get: function get() {
    return _ic_sms__or__text.default;
  }
});
Object.defineProperty(exports, "ic_sms__text", {
  enumerable: true,
  get: function get() {
    return _ic_sms__text.default;
  }
});
Object.defineProperty(exports, "ic_soho", {
  enumerable: true,
  get: function get() {
    return _ic_soho.default;
  }
});
Object.defineProperty(exports, "ic_sos__emergency", {
  enumerable: true,
  get: function get() {
    return _ic_sos__emergency.default;
  }
});
Object.defineProperty(exports, "ic_sound__active", {
  enumerable: true,
  get: function get() {
    return _ic_sound__active.default;
  }
});
Object.defineProperty(exports, "ic_student", {
  enumerable: true,
  get: function get() {
    return _ic_student.default;
  }
});
Object.defineProperty(exports, "ic_superwifi", {
  enumerable: true,
  get: function get() {
    return _ic_superwifi.default;
  }
});
Object.defineProperty(exports, "ic_tablet", {
  enumerable: true,
  get: function get() {
    return _ic_tablet.default;
  }
});
Object.defineProperty(exports, "ic_text", {
  enumerable: true,
  get: function get() {
    return _ic_text.default;
  }
});
Object.defineProperty(exports, "ic_top__up", {
  enumerable: true,
  get: function get() {
    return _ic_top__up.default;
  }
});
Object.defineProperty(exports, "ic_trackisafe", {
  enumerable: true,
  get: function get() {
    return _ic_trackisafe.default;
  }
});
Object.defineProperty(exports, "ic_travellers__info", {
  enumerable: true,
  get: function get() {
    return _ic_travellers__info.default;
  }
});
Object.defineProperty(exports, "ic_tutorials", {
  enumerable: true,
  get: function get() {
    return _ic_tutorials.default;
  }
});
Object.defineProperty(exports, "ic_tv", {
  enumerable: true,
  get: function get() {
    return _ic_tv.default;
  }
});
Object.defineProperty(exports, "ic_unified__communication", {
  enumerable: true,
  get: function get() {
    return _ic_unified__communication.default;
  }
});
Object.defineProperty(exports, "ic_upgrade", {
  enumerable: true,
  get: function get() {
    return _ic_upgrade.default;
  }
});
Object.defineProperty(exports, "ic_users", {
  enumerable: true,
  get: function get() {
    return _ic_users.default;
  }
});
Object.defineProperty(exports, "ic_v__car__dongle", {
  enumerable: true,
  get: function get() {
    return _ic_v__car__dongle.default;
  }
});
Object.defineProperty(exports, "ic_v__pet", {
  enumerable: true,
  get: function get() {
    return _ic_v__pet.default;
  }
});
Object.defineProperty(exports, "ic_v__sim__and__device", {
  enumerable: true,
  get: function get() {
    return _ic_v__sim__and__device.default;
  }
});
Object.defineProperty(exports, "ic_video", {
  enumerable: true,
  get: function get() {
    return _ic_video.default;
  }
});
Object.defineProperty(exports, "ic_vodafone__store__click__collect", {
  enumerable: true,
  get: function get() {
    return _ic_vodafone__store__click__collect.default;
  }
});
Object.defineProperty(exports, "ic_vodafone__store", {
  enumerable: true,
  get: function get() {
    return _ic_vodafone__store.default;
  }
});
Object.defineProperty(exports, "ic_voice__of__vodafone__alerts", {
  enumerable: true,
  get: function get() {
    return _ic_voice__of__vodafone__alerts.default;
  }
});
Object.defineProperty(exports, "ic_voicemail", {
  enumerable: true,
  get: function get() {
    return _ic_voicemail.default;
  }
});
Object.defineProperty(exports, "ic_warning", {
  enumerable: true,
  get: function get() {
    return _ic_warning.default;
  }
});
Object.defineProperty(exports, "ic_watch", {
  enumerable: true,
  get: function get() {
    return _ic_watch.default;
  }
});
Object.defineProperty(exports, "ic_white__paper", {
  enumerable: true,
  get: function get() {
    return _ic_white__paper.default;
  }
});
Object.defineProperty(exports, "ic_world", {
  enumerable: true,
  get: function get() {
    return _ic_world.default;
  }
});

var _ic_1st__month__free = _interopRequireDefault(require("./ic_1st__month__free"));

var _ic_3g = _interopRequireDefault(require("./ic_3g"));

var _ic_4g = _interopRequireDefault(require("./ic_4g"));

var _ic_4g__plus = _interopRequireDefault(require("./ic_4g__plus"));

var _ic_4g__plus__plus = _interopRequireDefault(require("./ic_4g__plus__plus"));

var _ic_5g = _interopRequireDefault(require("./ic_5g"));

var _ic_acceleration__low = _interopRequireDefault(require("./ic_acceleration__low"));

var _ic_acceleration = _interopRequireDefault(require("./ic_acceleration"));

var _ic_accelerationdle__mid = _interopRequireDefault(require("./ic_accelerationdle__mid"));

var _ic_accelerationdle = _interopRequireDefault(require("./ic_accelerationdle"));

var _ic_accessories = _interopRequireDefault(require("./ic_accessories"));

var _ic_add__ons__boosts = _interopRequireDefault(require("./ic_add__ons__boosts"));

var _ic_admin = _interopRequireDefault(require("./ic_admin"));

var _ic_alexa = _interopRequireDefault(require("./ic_alexa"));

var _ic_all__rewards = _interopRequireDefault(require("./ic_all__rewards"));

var _ic_apps = _interopRequireDefault(require("./ic_apps"));

var _ic_backspace = _interopRequireDefault(require("./ic_backspace"));

var _ic_barcode = _interopRequireDefault(require("./ic_barcode"));

var _ic_battery__low = _interopRequireDefault(require("./ic_battery__low"));

var _ic_battery = _interopRequireDefault(require("./ic_battery"));

var _ic_battery__really__low = _interopRequireDefault(require("./ic_battery__really__low"));

var _ic_bill = _interopRequireDefault(require("./ic_bill"));

var _ic_bill__or__report = _interopRequireDefault(require("./ic_bill__or__report"));

var _ic_bill__pay__phone = _interopRequireDefault(require("./ic_bill__pay__phone"));

var _ic_biometric__authentication = _interopRequireDefault(require("./ic_biometric__authentication"));

var _ic_birthday__greeting = _interopRequireDefault(require("./ic_birthday__greeting"));

var _ic_blog = _interopRequireDefault(require("./ic_blog"));

var _ic_bonus = _interopRequireDefault(require("./ic_bonus"));

var _ic_bracelet__active = _interopRequireDefault(require("./ic_bracelet__active"));

var _ic_bracelet__disabled = _interopRequireDefault(require("./ic_bracelet__disabled"));

var _ic_bracelet__generic = _interopRequireDefault(require("./ic_bracelet__generic"));

var _ic_bracelet__not__found = _interopRequireDefault(require("./ic_bracelet__not__found"));

var _ic_bracelet__off = _interopRequireDefault(require("./ic_bracelet__off"));

var _ic_bracelet__on = _interopRequireDefault(require("./ic_bracelet__on"));

var _ic_bracelet__put__on = _interopRequireDefault(require("./ic_bracelet__put__on"));

var _ic_bracelet__remove = _interopRequireDefault(require("./ic_bracelet__remove"));

var _ic_broadband = _interopRequireDefault(require("./ic_broadband"));

var _ic_broadband__or__wifi = _interopRequireDefault(require("./ic_broadband__or__wifi"));

var _ic_bundles = _interopRequireDefault(require("./ic_bundles"));

var _ic_business = _interopRequireDefault(require("./ic_business"));

var _ic_calculator = _interopRequireDefault(require("./ic_calculator"));

var _ic_calendar = _interopRequireDefault(require("./ic_calendar"));

var _ic_calls__contacts = _interopRequireDefault(require("./ic_calls__contacts"));

var _ic_camera = _interopRequireDefault(require("./ic_camera"));

var _ic_cancel = _interopRequireDefault(require("./ic_cancel"));

var _ic_case__study = _interopRequireDefault(require("./ic_case__study"));

var _ic_chart__bar = _interopRequireDefault(require("./ic_chart__bar"));

var _ic_chart__line = _interopRequireDefault(require("./ic_chart__line"));

var _ic_chat = _interopRequireDefault(require("./ic_chat"));

var _ic_clock__or__timed = _interopRequireDefault(require("./ic_clock__or__timed"));

var _ic_clock__or__timeout = _interopRequireDefault(require("./ic_clock__or__timeout"));

var _ic_cloud__download = _interopRequireDefault(require("./ic_cloud__download"));

var _ic_cloud__upload = _interopRequireDefault(require("./ic_cloud__upload"));

var _ic_cloud__upload__storage = _interopRequireDefault(require("./ic_cloud__upload__storage"));

var _ic_comment = _interopRequireDefault(require("./ic_comment"));

var _ic_community = _interopRequireDefault(require("./ic_community"));

var _ic_community__or__foundation = _interopRequireDefault(require("./ic_community__or__foundation"));

var _ic_complaints = _interopRequireDefault(require("./ic_complaints"));

var _ic_completed = _interopRequireDefault(require("./ic_completed"));

var _ic_connected__car = _interopRequireDefault(require("./ic_connected__car"));

var _ic_connected__devices = _interopRequireDefault(require("./ic_connected__devices"));

var _ic_connectivity = _interopRequireDefault(require("./ic_connectivity"));

var _ic_consultant = _interopRequireDefault(require("./ic_consultant"));

var _ic_contest = _interopRequireDefault(require("./ic_contest"));

var _ic_control__panel = _interopRequireDefault(require("./ic_control__panel"));

var _ic_converged__proposition = _interopRequireDefault(require("./ic_converged__proposition"));

var _ic_country__or__international = _interopRequireDefault(require("./ic_country__or__international"));

var _ic_dashboard = _interopRequireDefault(require("./ic_dashboard"));

var _ic_data = _interopRequireDefault(require("./ic_data"));

var _ic_deals = _interopRequireDefault(require("./ic_deals"));

var _ic_delivery = _interopRequireDefault(require("./ic_delivery"));

var _ic_desktop = _interopRequireDefault(require("./ic_desktop"));

var _ic_device__overview = _interopRequireDefault(require("./ic_device__overview"));

var _ic_diagnostics = _interopRequireDefault(require("./ic_diagnostics"));

var _ic_dial__pad = _interopRequireDefault(require("./ic_dial__pad"));

var _ic_document__doc = _interopRequireDefault(require("./ic_document__doc"));

var _ic_document__jpg = _interopRequireDefault(require("./ic_document__jpg"));

var _ic_document = _interopRequireDefault(require("./ic_document"));

var _ic_document__pdf = _interopRequireDefault(require("./ic_document__pdf"));

var _ic_document__png = _interopRequireDefault(require("./ic_document__png"));

var _ic_document__ppt = _interopRequireDefault(require("./ic_document__ppt"));

var _ic_document__rtf = _interopRequireDefault(require("./ic_document__rtf"));

var _ic_document__svg = _interopRequireDefault(require("./ic_document__svg"));

var _ic_document__xls = _interopRequireDefault(require("./ic_document__xls"));

var _ic_document__zip = _interopRequireDefault(require("./ic_document__zip"));

var _ic_download = _interopRequireDefault(require("./ic_download"));

var _ic_e__sim = _interopRequireDefault(require("./ic_e__sim"));

var _ic_edit = _interopRequireDefault(require("./ic_edit"));

var _ic_engineer = _interopRequireDefault(require("./ic_engineer"));

var _ic_enterprise = _interopRequireDefault(require("./ic_enterprise"));

var _ic_entertainment = _interopRequireDefault(require("./ic_entertainment"));

var _ic_environment = _interopRequireDefault(require("./ic_environment"));

var _ic_fall__detection__emergency = _interopRequireDefault(require("./ic_fall__detection__emergency"));

var _ic_family = _interopRequireDefault(require("./ic_family"));

var _ic_filter = _interopRequireDefault(require("./ic_filter"));

var _ic_find__and__ring__your__device = _interopRequireDefault(require("./ic_find__and__ring__your__device"));

var _ic_fixed__line = _interopRequireDefault(require("./ic_fixed__line"));

var _ic_focus = _interopRequireDefault(require("./ic_focus"));

var _ic_game__console = _interopRequireDefault(require("./ic_game__console"));

var _ic_generic__tariff__plan = _interopRequireDefault(require("./ic_generic__tariff__plan"));

var _ic_gravity = _interopRequireDefault(require("./ic_gravity"));

var _ic_gyroscope = _interopRequireDefault(require("./ic_gyroscope"));

var _ic_healthy__living = _interopRequireDefault(require("./ic_healthy__living"));

var _ic_help__at__hand = _interopRequireDefault(require("./ic_help__at__hand"));

var _ic_help = _interopRequireDefault(require("./ic_help"));

var _ic_home = _interopRequireDefault(require("./ic_home"));

var _ic_idea__or__innovation = _interopRequireDefault(require("./ic_idea__or__innovation"));

var _ic_incoming__call = _interopRequireDefault(require("./ic_incoming__call"));

var _ic_info__circle = _interopRequireDefault(require("./ic_info__circle"));

var _ic_infographic = _interopRequireDefault(require("./ic_infographic"));

var _ic_interchangable__batteries = _interopRequireDefault(require("./ic_interchangable__batteries"));

var _ic_kippy__device = _interopRequireDefault(require("./ic_kippy__device"));

var _ic_landline__or__call = _interopRequireDefault(require("./ic_landline__or__call"));

var _ic_location = _interopRequireDefault(require("./ic_location"));

var _ic_mail__new = _interopRequireDefault(require("./ic_mail__new"));

var _ic_mesh__wifi__and__repeater = _interopRequireDefault(require("./ic_mesh__wifi__and__repeater"));

var _ic_minutes__sms = _interopRequireDefault(require("./ic_minutes__sms"));

var _ic_mobile = _interopRequireDefault(require("./ic_mobile"));

var _ic_monitor__brightness__contrast = _interopRequireDefault(require("./ic_monitor__brightness__contrast"));

var _ic_music__and__movies = _interopRequireDefault(require("./ic_music__and__movies"));

var _ic_mute = _interopRequireDefault(require("./ic_mute"));

var _ic_my__vodafone = _interopRequireDefault(require("./ic_my__vodafone"));

var _ic_my__vodafone__or__my__profile = _interopRequireDefault(require("./ic_my__vodafone__or__my__profile"));

var _ic_need__help = _interopRequireDefault(require("./ic_need__help"));

var _ic_network__signal = _interopRequireDefault(require("./ic_network__signal"));

var _ic_newest__tech = _interopRequireDefault(require("./ic_newest__tech"));

var _ic_news = _interopRequireDefault(require("./ic_news"));

var _ic_night__vision = _interopRequireDefault(require("./ic_night__vision"));

var _ic_notifications = _interopRequireDefault(require("./ic_notifications"));

var _ic_notifications__muted = _interopRequireDefault(require("./ic_notifications__muted"));

var _ic_outgoing__call = _interopRequireDefault(require("./ic_outgoing__call"));

var _ic_padlock__close = _interopRequireDefault(require("./ic_padlock__close"));

var _ic_padlock__open = _interopRequireDefault(require("./ic_padlock__open"));

var _ic_parental__control = _interopRequireDefault(require("./ic_parental__control"));

var _ic_pause = _interopRequireDefault(require("./ic_pause"));

var _ic_payg = _interopRequireDefault(require("./ic_payg"));

var _ic_payg__plans = _interopRequireDefault(require("./ic_payg__plans"));

var _ic_payment = _interopRequireDefault(require("./ic_payment"));

var _ic_photos = _interopRequireDefault(require("./ic_photos"));

var _ic_placeholder = _interopRequireDefault(require("./ic_placeholder"));

var _ic_play = _interopRequireDefault(require("./ic_play"));

var _ic_pop__out = _interopRequireDefault(require("./ic_pop__out"));

var _ic_portals__for__videos = _interopRequireDefault(require("./ic_portals__for__videos"));

var _ic_prepare = _interopRequireDefault(require("./ic_prepare"));

var _ic_price__promise = _interopRequireDefault(require("./ic_price__promise"));

var _ic_price__tag = _interopRequireDefault(require("./ic_price__tag"));

var _ic_public__sector = _interopRequireDefault(require("./ic_public__sector"));

var _ic_public__wifi = _interopRequireDefault(require("./ic_public__wifi"));

var _ic_qr__code = _interopRequireDefault(require("./ic_qr__code"));

var _ic_raffles = _interopRequireDefault(require("./ic_raffles"));

var _ic_return__product = _interopRequireDefault(require("./ic_return__product"));

var _ic_roaming = _interopRequireDefault(require("./ic_roaming"));

var _ic_router = _interopRequireDefault(require("./ic_router"));

var _ic_saving = _interopRequireDefault(require("./ic_saving"));

var _ic_screen__repair = _interopRequireDefault(require("./ic_screen__repair"));

var _ic_search = _interopRequireDefault(require("./ic_search"));

var _ic_security__camera = _interopRequireDefault(require("./ic_security__camera"));

var _ic_security = _interopRequireDefault(require("./ic_security"));

var _ic_settings = _interopRequireDefault(require("./ic_settings"));

var _ic_shopping__trolley = _interopRequireDefault(require("./ic_shopping__trolley"));

var _ic_sim = _interopRequireDefault(require("./ic_sim"));

var _ic_sim__swap = _interopRequireDefault(require("./ic_sim__swap"));

var _ic_small__and__lightweight = _interopRequireDefault(require("./ic_small__and__lightweight"));

var _ic_sme = _interopRequireDefault(require("./ic_sme"));

var _ic_sms__or__text = _interopRequireDefault(require("./ic_sms__or__text"));

var _ic_sms__text = _interopRequireDefault(require("./ic_sms__text"));

var _ic_soho = _interopRequireDefault(require("./ic_soho"));

var _ic_sos__emergency = _interopRequireDefault(require("./ic_sos__emergency"));

var _ic_sound__active = _interopRequireDefault(require("./ic_sound__active"));

var _ic_student = _interopRequireDefault(require("./ic_student"));

var _ic_superwifi = _interopRequireDefault(require("./ic_superwifi"));

var _ic_tablet = _interopRequireDefault(require("./ic_tablet"));

var _ic_text = _interopRequireDefault(require("./ic_text"));

var _ic_top__up = _interopRequireDefault(require("./ic_top__up"));

var _ic_trackisafe = _interopRequireDefault(require("./ic_trackisafe"));

var _ic_travellers__info = _interopRequireDefault(require("./ic_travellers__info"));

var _ic_tutorials = _interopRequireDefault(require("./ic_tutorials"));

var _ic_tv = _interopRequireDefault(require("./ic_tv"));

var _ic_unified__communication = _interopRequireDefault(require("./ic_unified__communication"));

var _ic_upgrade = _interopRequireDefault(require("./ic_upgrade"));

var _ic_users = _interopRequireDefault(require("./ic_users"));

var _ic_v__car__dongle = _interopRequireDefault(require("./ic_v__car__dongle"));

var _ic_v__pet = _interopRequireDefault(require("./ic_v__pet"));

var _ic_v__sim__and__device = _interopRequireDefault(require("./ic_v__sim__and__device"));

var _ic_video = _interopRequireDefault(require("./ic_video"));

var _ic_vodafone__store__click__collect = _interopRequireDefault(require("./ic_vodafone__store__click__collect"));

var _ic_vodafone__store = _interopRequireDefault(require("./ic_vodafone__store"));

var _ic_voice__of__vodafone__alerts = _interopRequireDefault(require("./ic_voice__of__vodafone__alerts"));

var _ic_voicemail = _interopRequireDefault(require("./ic_voicemail"));

var _ic_warning = _interopRequireDefault(require("./ic_warning"));

var _ic_watch = _interopRequireDefault(require("./ic_watch"));

var _ic_white__paper = _interopRequireDefault(require("./ic_white__paper"));

var _ic_world = _interopRequireDefault(require("./ic_world"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }